import { useCallback, useEffect, useState } from "react";
import MailingsService from "../../../services/mailings";

export const useFetchCount = () => {
  const [total, setTotal] = useState<number>(0);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [request, setRequest] = useState<any>({
    pageNumber: 1,
    pageSize: 50,
    page: 0,
  });

  const onPageChange = useCallback(
    (pageNumber: number, pageSize = 50) => {
      const newRequest = { ...request, pageNumber, pageSize };

      setRequest(newRequest);
    },
    [request]
  );

  const fetchCount = useCallback(() => {
    setIsLoading(true);

    MailingsService.fetchCount(request)
      .then((res: number) => {
        setTotal(res);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [request]);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  return { total, isLoading, request, setRequest, fetchCount, onPageChange };
};
